/**
 * EthicsGlobal Widget - Main Entry Point
 *
 * This file exports the widget for both module and script tag usage.
 *
 * Usage with npm/ES modules:
 * import { EthicsGlobal } from '@ethicsglobal/widget';
 * const widget = EthicsGlobal.init({ container: '#form', domain: 'client.com' });
 *
 * Usage with script tag:
 * <script src="ethicsglobal-widget.umd.js"></script>
 * <script>
 *   const widget = EthicsGlobal.init({ container: '#form', domain: 'client.com' });
 * </script>
 */

// Main exports
export { EthicsGlobalWidget, EthicsGlobal } from './EthicsGlobalWidget.jsx';

// Utility exports
export { createWidgetStore, widgetStore } from './widget-store';
export { createWidgetApiClient } from './widget-api';
export { WidgetFormIsolated } from './WidgetFormIsolated.jsx';
export { WidgetPreviewForm, WidgetRenderInput } from './WidgetPreviewForm.jsx';

// Isolated Components
export * from './components/WidgetGrid';
export * from './components/WidgetInputs';

// Default export
import { EthicsGlobalWidget } from './EthicsGlobalWidget.jsx';
export default EthicsGlobalWidget;

// Auto-initialize if there's a global config (legacy support)
if (typeof window !== 'undefined') {
  // Support for legacy FormBuilderConfig
  if (window.FormBuilderConfig) {
    const { containerId, options } = window.FormBuilderConfig;
    console.warn('[EthicsGlobal] FormBuilderConfig is deprecated. Use EthicsGlobal.init() instead.');

    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        window.EthicsGlobal.init({
          container: `#${containerId}`,
          ...options
        });
      });
    } else {
      window.EthicsGlobal.init({
        container: `#${containerId}`,
        ...options
      });
    }
  }

  // Support for EthicsGlobalConfig
  if (window.EthicsGlobalConfig) {
    const config = window.EthicsGlobalConfig;

    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        window.EthicsGlobal.init(config);
      });
    } else {
      window.EthicsGlobal.init(config);
    }
  }

  // Process any queued commands from async loader
  if (window.EthicsGlobal && window.EthicsGlobal.q && window.EthicsGlobal._processQueue) {
    window.EthicsGlobal._processQueue();
  }
}
